import { Heading } from '@chakra-ui/react'
import { useMiniCalendar } from '../../../../contexts/MiniCalendarContext/Provider'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { capitalizeString } from 'utils/transforms/string'

export default function Title() {
  const { view, activeDay } = useMiniCalendar()

  function getTitle() {
    if (view === 'MONTH') {
      return `${capitalizeString(
        format(new Date(activeDay), 'MMMM', {
          locale: ptBR,
        })
      )} de ${format(new Date(activeDay), 'yyyy')}`
    }
    return 'Título'
  }

  return <Heading size="xs">{getTitle()}</Heading>
}
